import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=81af2cfa&scoped=true&"
import script from "./Status.vue?vue&type=script&lang=js&"
export * from "./Status.vue?vue&type=script&lang=js&"
import style0 from "./Status.vue?vue&type=style&index=0&id=81af2cfa&lang=scss&scoped=true&"
import style1 from "./Status.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af2cfa",
  null
  
)

export default component.exports